import { Link } from 'react-router-dom';
import './Animals.css';

export default function Animals() {
  return (
    <div className="animals-page">
      <div className="animals-container">
        <div className="animals-header">
          <h1>Животные</h1>
          <Link to="/animals/create" className="animals-create-button">
            + Добавить животное
          </Link>
        </div>
        <div className="animals-content">
          <p>Здесь будет список животных</p>
        </div>
      </div>
    </div>
  );
}
